"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.ListItemContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.ListItemContainer = styled_components_1.default.div `
  ${style_1.default.Design.Definition.Container};
  background: ${style_1.default.Color.Gray.S200};
`;
const ListItem = ({ children, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.ListItemContainer, { children: children }));
};
exports.ListItem = ListItem;
